<!--
单页面示例：
-->
<template>
  <scroll-right-frame class="demo-spage-5">

  </scroll-right-frame>
</template>
<script>
  import ScrollRightFrame from '../../../components/scroll-right-frame'
  export default {
    name: 'demo-spage-5',
    components: {ScrollRightFrame}
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/custom/components/demo/demo-spage-5.vue